import * as React from 'react';
import { observer } from 'mobx-react';

import {
  VKCreationStore,
  VKCreationStoreProvider
} from 'stores/channelCreationStores';

import VKAccount from './VKAccount';
import NotConnectedStub from './NotConnectedStub';
import Groups from './Groups';

import './VK.modules.scss';

type VKProps = {
  channelCreationStore: VKCreationStore;
};

const VK: React.FC<VKProps> = ({ channelCreationStore }) => {
  React.useEffect(() => {
    channelCreationStore.init();

    return () => {
      channelCreationStore.reset();
    };
  }, []);

  return (
    <VKCreationStoreProvider value={{ store: channelCreationStore }}>
      <div styleName="vk">
        <VKAccount styleName="vk__account" />
        <div styleName="vk__content">
          {!channelCreationStore.vkAccount && <NotConnectedStub />}
          {channelCreationStore.vkAccount && <Groups />}
        </div>
      </div>
    </VKCreationStoreProvider>
  );
};

export default observer(VK);
